import Header from '../components/webnorte/Header';
import HeroSection from '../components/webnorte/HeroSection';
import PlansSection from '../components/webnorte/PlansSection';
import WebnorTVSection from '../components/webnorte/WebnorTVSection';
import BenefitsSection from '../components/webnorte/BenefitsSection';
import CoverageSection from '../components/webnorte/CoverageSection';
import TestimonialsSection from '../components/webnorte/TestimonialsSection';
import FAQSection from '../components/webnorte/FAQSection';
import AppBannerSection from '../components/webnorte/AppBannerSection';
import CTASection from '../components/webnorte/CTASection';
import Footer from '../components/webnorte/Footer';
import WhatsAppFloat from '../components/webnorte/WhatsAppFloat';
import HighlightsCarousel from 'components/webnorte/HighlightsCarousel';
import CitySelectionModal from '../components/webnorte/CitySelectionModal';

export default function Home() {
  return (
    <div>
      <Header />
      <main>
        <HeroSection />
        <PlansSection />
        <WebnorTVSection />
        <HighlightsCarousel/>
        <BenefitsSection />
        <CoverageSection />
        <TestimonialsSection />
        <FAQSection />
        <AppBannerSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CitySelectionModal />
    </div>
  );
}